import './../scss/main.scss';
import { App } from 'App';
import { DomReady, getDeviceMetric, getConfigBase } from '@jollywise/jollygoodgame';
import { Load } from './game/scenes/Load';
import { CopyPluginTurner } from './components/CopyPluginTurner';

// safari 10 fix
var ua = window.navigator.userAgent;
var msie = ua.indexOf('MSIE');
if (!(msie > 0 || !!ua.match(/Trident.*rv\:11\./))) EventTarget = EventTarget || Element;

const paths = { base: './', assets: 'assets/' };
const config = getConfigBase({
  components: {
    loader: { data: { displayScene: Load } },
    copy: CopyPluginTurner,
  },
});

const forceCanvas = (deviceMetric) => {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE');
  if (msie > 0 || !!ua.match(/Trident.*rv\:11\./) || deviceMetric.platform.kindle) return true;
  if (
    !!ua.match(/SM-T550/) ||
    !!ua.match(/SM-T350/) ||
    !!ua.match(/SM-T580/) ||
    !!ua.match(/SamsungBrowser/)
  )
    return true;
  if (deviceMetric.platform.os === 'fire' && deviceMetric.category === 'LOW_END') return true;
  return false;
};

const deviceMetric = getDeviceMetric();

config.type = forceCanvas(deviceMetric) ? Phaser.CANVAS : config.type;

// disable aliasing on all lowend/midend/kindles and ios smartphone devices
// const disableAntiAlias =
//   deviceMetric.category === 'LOW_END' ||
//   deviceMetric.platform.kindle ||
//   (deviceMetric.platform.os === 'ios' && deviceMetric.platform.type === 'smartphone');

const disableAntiAlias = false;

config.render = {
  antialias: disableAntiAlias ? false : true,
  antialiasGL: disableAntiAlias ? false : true,
  batchSize: disableAntiAlias ? 2048 : 4096,
  clearBeforeRender: false,
  transparent: false,
};

const params = new URLSearchParams(window.location.search);
config.locale = params.get('locale') || GameSettings.language || 'en';

DomReady(() => {
  new App({ config, paths });
});
